// Asset catalog (Norwegian).
window.PlummeI18n.register('no', {
  "supplierPay.correct": "Korriger leverandøroppgjør",
  "purchaseFlow.subtitle": "Kjøp, leverandørfakturaer og oppgjør",
  "purchaseFlow.type": "Type",
  "supplierPay.settlement": "Oppgjør",

  "asset.impairmentCancelled": "Annullert nedskrivning",
  "asset.impairmentCorrectionBlocked": "Velg en aktiv nedskrivning med entydig eiendel og oppgi en begrunnelse. Korriger senere eiendelsbilag først. Solgte og importerte eiendeler krever gjennomgang.",
  "asset.correctionEntriesRequired": "Korrigeringen krever entydige eiendelsbilag i samme åpne år, senest på korrigeringsdatoen.",
  "asset.alreadyCancelled": "Kjøpet er allerede annullert.",
  "asset.cancelCurrentDate": "Annullering bruker dagens regnskapsdato.",
  "asset.cancelWholePurchase": "Velg en usolgt eiendel fra et helt kjøpsbilag. Blandede kjøp krever korrigering av dokumentet.",
  "asset.cancelSameYear": "Dokumenter korrigeringen i samme åpne anskaffelsesår.",

  "asset.autoCancelBody": "Plumme reverserer hele kjøpet, MVA og tilknyttede betalinger samt eiendelens bokførte avskrivninger og nedskrivninger. Originalbilagene beholdes med sporbare motposteringer.",
  "err.purchase.invoiceNumberRequired": "Legg inn leverandørens fakturanummer før bokføring.",
  "err.supplierPayment.reverseUseFirst": "Reverser tilbakebetaling og bruk av tilgodebeløpet før betalingen reverseres.",
  "supplierPay.description": "Betaling av leverandørfaktura {number}",
  "supplierPay.total": "Fakturabeløp",
  "supplierPay.paid": "Betalt / oppgjort",
  "supplierPay.remaining": "Gjenstår",
  "supplierPay.available": "Til gode hos leverandøren",
  "supplierPay.register": "Registrer betaling",
  "supplierPay.link": "Koble eksisterende postering",
  "supplierPay.history": "Betalingshistorikk",
  "supplierPay.selectInvoice": "Faktura som betales",
  "supplierPay.noInvoice": "Ingen faktura valgt",
  "supplierPay.overpayment": "Overskytende {amount} blir stående til gode hos leverandøren.",
  "supplierPay.open": "Åpne",
  "supplierPay.openTotal": "Ubetalte fakturaer",

  'err.asset.reverseSaleBeforeAcquisition': 'Angre salget før du endrer eller annullerer anskaffelsen.',
  'asset.tabDrafts': 'Utkast ({n})',
  'asset.bookValueAtSale': 'Regnskapsverdi på salgsdato',
  'asset.taxDepreciation': 'Skattemessig avskrivning',
  'asset.bookTaxExplanation': 'Regnskapsverdien følger eiendelens avskrivningsplan. Skatteverdien beregnes separat etter saldogruppen. Skattetallene gjelder hele gruppen når flere eiendeler inngår.',
  'asset.automationActivate': 'Aktiver og bokfør',
  'asset.automationCatchUp': 'Kontroller og bokfør utestående',
  'asset.automationPause': 'Sett automatikk på pause',
  'asset.automationConfirmEnable': 'Bekreft og bokfør',
  'asset.automationConfirmAmount': 'Du godkjenner avskrivningsplanene og bokfører {amount} for fullførte måneder til og med {date}. Deretter bokføres nye fullførte måneder automatisk.',
  'asset.automationPauseExplanation': 'Fremtidig automatisk bokføring settes på pause. Allerede bokførte avskrivninger beholdes. Avskrivningsbehovet forsvinner ikke; utestående beløp må fortsatt bokføres.',
  'asset.automationEnabledSaved': 'Automatikk godkjent og fullførte måneder bokført.',
  'asset.automationPausedSaved': 'Automatikk satt på pause. Bokførte avskrivninger er beholdt.',
  'asset.automationSaveFailed': 'Endringen kunne ikke bekreftes. Kontroller status før du prøver igjen.',
  'asset.automationPostingNotConfirmed': 'Bokføringen er ikke bekreftet. Kontroller utestående beløp og bilag. Ikke legg til grunn at avskrivningene er bokført bare fordi automatikk er aktivert.',
  'asset.automationBasisChanged': 'Grunnlaget er endret. Lukk dialogen og kontroller beløpene på nytt.',
  'asset.automationRequestUncertain': 'Serveren svarte ikke i tide. Bokføringen kan ha blitt gjennomført. Oppdater regnskapet og kontroller bilagene før du prøver igjen.',
  'asset.automationStatusAwaiting': 'Automatikk er aktivert. Ingen avskrivninger er bokført ennå.',
  'asset.postingReviewRequired': 'Må avstemmes',
  'asset.projectedYearEndValue': 'Beregnet verdi ved årsslutt (plan)',
  'asset.usefulLifeSuggestionHelp': 'Levetiden er et redigerbart forslag basert på gruppen. Tilpass til forventet bruk; dette er ikke en skatteregel.',
  'asset.advancedOptions': 'Avansert',
  'asset.advancedOptionsHelp': 'Tilpass levetid, restverdi eller ekstra verdifall ved behov. Standardverdiene er allerede fylt inn.',
  'asset.editAdjustments': 'Tilpass',
  'asset.hideAdjustments': 'Skjul',
  'asset.automaticPlanSummary': 'Levetid: {years} år. Restverdi: {residual}.',
  'asset.noExtraImpairmentDefault': 'Ingen ekstra nedskrivning som standard.',
  'asset.optionalDocumentation': 'Dokumentasjon / begrunnelse (valgfritt)',

  'asset.title': 'Eiendeler',
  'asset.subtitle': 'Utstyr og verdier bedriften eier over tid',
  'asset.new': 'Ny eiendel',
  'asset.info': 'Info',
  'asset.accounting': 'Regnskap',
  'asset.moreActions': 'Flere handlinger',
  'asset.automationStatusTitle': 'Automatisk månedsbokføring',
  'asset.automationStatusActive': 'Aktiv. Siste bokføring til og med {date}.',
  'asset.automationStatusDefault': 'På som standard. Nye eiendeler bokføres automatisk hver måned etter registrering.',
  'asset.taxAutomaticTitle': 'Skattemessig avskrivning beregnes automatisk',
  'asset.taxAutomaticHelp': 'Plumme bruker ordinære skatteregler og foreslår beløpene for {year}. Du trenger normalt ikke gjøre noe her.',
  'asset.taxAutomaticDepreciation': 'Beregnet avskrivning',
  'asset.taxAutomaticIncome': 'Beregnet inntektsføring',
  'asset.taxAutomaticDeduction': 'Beregnet tapsfradrag',
  'asset.taxAdvancedChoices': 'Avanserte valg',
  'asset.taxAdvancedHelp': 'Bruk bare dette når du skal avvike fra Plumme sitt forslag eller registrere inngående gevinst- og tapskonto ved systembytte.',
  'asset.changeTaxElection': 'Endre skattemessig valg',
  'asset.taxElectionCurrentDefault': 'Plumme sitt automatiske forslag for valgt saldo er {amount}.',
  'asset.taxElectionOverrideRequired': 'Oppgi et beløp som skal avvike fra det automatiske forslaget.',
  'asset.taxElectionReasonRequired': 'Skriv hvorfor du overstyrer det automatiske forslaget.',
  'asset.automationStatusOff': 'Av. Aktiver én gang for å bokføre fullførte måneder automatisk.',
  'asset.automationStatusReview': 'Satt på vent. Kontroller planene og godkjenn automatikk på nytt.',
  'asset.automationApprovalNote': 'Godkjent automatisk månedlig bokføring av regnskapsmessige avskrivninger.',
  'asset.automationApprovalFailed': 'Eiendelen ble registrert, men automatisk månedsbokføring kunne ikke aktiveres. Kontroller status på eiendelssiden.',
  'asset.autoPostingActive': 'Automatisk månedsbokføring er standard',
  'asset.monthlyDepreciationPreview': 'Regnskapsmessig avskrivning blir omtrent {amount} per måned og bokføres automatisk etter registrering.',
  'asset.monthlyDepreciationPreviewOff': 'Automatisk månedsbokføring er deaktivert under Innstillinger – Regnskap.',
  'asset.manageInSettings': 'Administrer i innstillinger',
  'asset.special.financing': 'Lån og finansiering',
  'asset.special.tradeIn': 'Innbytte',
  'asset.special.partialSale': 'Delsalg',
  'asset.special.property': 'Fast eiendom',
  'asset.specialCasesHelp': 'Praktisk veiledning for situasjoner som krever særskilt dokumentasjon eller oppdeling.',
  'asset.automationStopNote': 'Automatisk månedlig bokføring stoppet av bruker.',
  'asset.unpostedDepreciation': 'Gjenstår å bokføre: {amount} til og med {date}.',
  'asset.importedHistory': 'Importert historikk',
  'asset.importedHistoryHelp': 'Historisk eiendel importert fra et annet regnskapssystem. Verdier og avskrivninger vises fra importsporet og bokføres ikke på nytt i Plumme.',
  'asset.edit': 'Rediger eiendel',
  'asset.registerSold': 'Registrer som solgt',
  'asset.moreOptions': 'Flere valg',
  'asset.reclassifyPurchase': 'Gjør om til vanlig kjøp',
  'asset.reclassifyTitle': 'Gjør om til vanlig kjøp',
  'err.asset.reverseReclassificationBeforeAcquisition': 'Reverser omklassifiseringen av eiendelen før du annullerer kjøpsbilaget.',
  "asset.acquisitionLockedTitle": "Hvorfor er handlingene sperret?",
  "asset.acquisitionLockedSold": "Eiendelen er solgt. Salget må reverseres før kjøpet kan korrigeres.",
  "asset.acquisitionLockedReview": "Bokføringen må avklares før kjøpet kan korrigeres.",
  "asset.acquisitionLockedDepreciation": "Plumme beregner og bokfører sporbare motposteringer når du velger korrigering i menyen. Gjør om til vanlig kjøp beholder kjøpet og MVA. Annuller eller feilregistrert reverserer kjøpet og tilknyttede avskrivninger og nedskrivninger. Låste perioder og avstemte betalinger må avklares først.",
  "asset.correctCapitalization": "Korriger feilaktig aktivering",
  "asset.correctCapitalizationBody": "Bruk dette bare når kjøpet er riktig, men skulle vært kostnadsført. Avskrivningene reverseres og kostprisen flyttes til valgt kostnadskonto i én lagring. Originalbilag, MVA og betalinger beholdes. Datoen må være etter siste avskrivning i samme åpne år. Gruppeavskrivninger og nedskrivninger krever særskilt gjennomgang.",
  'asset.reclassifyBody': 'Bruk dette når kjøpet ikke skulle vært registrert som eiendel. Originalbilaget beholdes. Et eget korrigeringsbilag flytter kostprisen til valgt kostnadskonto på datoen du velger.',
  'asset.expenseAccount': 'Kostnadskonto',
  'asset.correctionReason': 'Årsak',
  'asset.correctionReasonPh': 'F.eks. under beløpsgrensen / feil klassifisering',
  'asset.reclassifiedToast': 'Kjøpet er gjort om til vanlig kjøp.',
  'asset.reclassifyError': 'Kunne ikke gjøre eiendelen om til vanlig kjøp.',
  'asset.annulPurchase': 'Annuler kjøpsbilag',
  'asset.annulTitle': 'Annuler kjøpsbilag',
  'asset.annulBody': 'Bruk dette når hele kjøpsbilaget er feil eller dobbeltført. Bilaget slettes ikke fra historikken, men føringen tas ut av rapporter og saldobalanse.',
  'asset.annulLocksTitle': 'Kan være låst av MVA, bank eller årsavslutning',
  'asset.annulLocksBody': 'Hvis perioden er levert, bankavstemt eller årsavsluttet, må den åpnes eller korrigeres før bilaget kan annulleres.',
  'asset.annulReasonPh': 'F.eks. dobbeltført bilag / feil opplasting',
  'asset.annulledToast': 'Kjøpsbilaget er annullert.',
  'asset.annulError': 'Kunne ikke annullere kjøpsbilaget.',
  'asset.markMistaken': 'Marker eiendel som feilregistrert',
  'asset.saleDate': 'Salgsdato',
  'asset.bookValueShort': 'Regnskapsverdi',
  'asset.saleAmountExVat': 'Salgsbeløp uten mva',
  'asset.vat': 'Mva',
  'asset.howRegisterSale': 'Hvordan vil du registrere salget?',
  'asset.continueTitle': 'Fortsett?',
  'asset.continue': 'Fortsett',
  'asset.undoDeleteTitle': 'Angre sletting?',
  'asset.undoDelete': 'Angre sletting',
  'asset.undoSaleTitle': 'Angre salg?',
  'asset.undoSale': 'Angre salg',
  'asset.saveDraft': 'Lagre utkast',
  'asset.name': 'Navn på driftsmiddel',
  'asset.namePh': 'F.eks. MacBook Pro 16"',
  'asset.depreciationNote': 'Dette kjøpet registreres som driftsmiddel og avskrives ved årsavslutning.',
  'asset.supplierPurchase': 'Leverandørkjøp',
  'asset.supplier': 'Leverandør',
  'asset.invoiceNumber': 'Fakturanummer',
  'asset.invoiceNumberPh': 'F.eks. 100245',
  'asset.lines': 'Linjer',
  'asset.linePh': 'F.eks. maskin, PC eller verktøy',
  'asset.account': 'Driftsmiddelkonto',
  'asset.accountDepreciationHint': 'Avskrives med inntil {rate} % per år ved årsavslutning.',
  'asset.vatRate': 'MVA-sats',
  'asset.addLine': 'Legg til linje',
  'asset.paidBy': 'Betalt av',
  'asset.payOperating': 'Driftskonto - 1920',
  'asset.payCash': 'Kontant - 1900',
  'asset.payPrivate': 'Privat - 2060',
  'asset.payLoan': 'Betalt ved låneopptak - 2250',
  'asset.splitPayment': 'Del betalingen',
  'asset.partPayments': 'Delbetalinger',
  'asset.fullPayment': 'Full betaling',
  'asset.addPartPayment': 'Legg til delbetaling',
  'asset.uploadFile': 'Last opp fil',
  'asset.dropFiles': 'Dra og slipp filer hit, eller velg fra maskinen.',
  'asset.removeAttachment': 'Fjern vedlegg',
  'asset.sold': 'Solgt',
  'asset.depreciated': 'Avskrevet',
  'asset.active': 'Aktiv',
  'asset.viewsTitle': 'Visninger',
  'asset.viewsHelp': 'Filtrer listen: «Aktive» er eiendeler med gjenstående bokført verdi som fortsatt avskrives, «Avskrevne» er ferdig nedskrevet til 0, «Solgte» er avhendet, og «Alle» viser alt.',
  'asset.noneInView': 'Ingen eiendeler i denne visningen ennå',
  'asset.fromPurchase': 'Registrer fra et kjøp',
  'asset.group': 'Gruppe',
  'asset.groupHelp': 'Saldogruppen avgjør avskrivningssatsen — hvor stor andel som kan avskrives skattemessig hvert år. F.eks. gruppe C (varebiler) og gruppe D (maskiner, inventar) har ulike satser fastsatt av Skatteetaten.',
  'asset.depreciatedHelp': 'Summen som er kostnadsført så langt — altså hvor mye av kostprisen som allerede er avskrevet over årene. Kostpris minus avskrevet gir bokført verdi.',
  'asset.bookValue': 'Bokført verdi',
  'asset.bookValueHelp': 'Eiendelens gjenstående verdi i regnskapet nå — kostpris minus det som er avskrevet. Dette er beløpet som står igjen å avskrive over kommende år.',
  'asset.declining': 'Saldoavskrivning og skjemaer',
  'asset.decliningHelp': 'Saldoavskrivning er den vanligste avskrivningsmetoden: hvert år avskrives en fast prosent av gjenstående saldo per gruppe. Tabellen viser grunnlaget per saldogruppe. RF-1084 og RF-1217 er Skatteetatens skjemaer for avskrivning og midlertidige forskjeller — Plumme fyller dem ut fra tallene her.',
  'asset.opening': 'Inngående',
  'asset.additions': 'Nyanskaffelser',
  'asset.disposals': 'Salg',
  'asset.movements': 'Bevegelser',
  'asset.depreciation': 'Avskrivning',
  'asset.closing': 'Utgående saldo',
  'asset.groupDFallback': 'Saldogruppe d - personbiler, maskiner og inventar',
  'asset.attachmentFallback': 'Vedlegg',
  'asset.pageTitleHelp': 'Eiendeler (driftsmidler) er større ting bedriften eier og bruker over flere år — PC, kjøretøy, maskiner, inventar. De kostnadsføres ikke med én gang, men avskrives: kostnaden fordeles litt hvert år over levetiden. Her holder Plumme styr på avskrivning og skjemaverdier for deg.',
  'asset.pageAddHelp': 'Registrer en ny eiendel når ett driftsmiddel har en kostpris på minst 30 000 kr og forventet brukstid på minst tre år. Grensen gjelder ikke fakturasummen alene.',
  'asset.emptyText': 'Eiendeler er ting bedriften eier og bruker over flere år — som en PC, et kjøretøy eller verktøy. De avskrives litt hvert år. Registrer en eiendel fra et kjøp, så holder vi styr på avskrivning og skjemaverdier for deg.',
  'asset.tabActive': 'Aktive ({n})',
  'asset.tabDepreciated': 'Avskrevne ({n})',
  'asset.tabSold': 'Solgte ({n})',
  'asset.tabAll': 'Alle ({n})',
  'asset.colAsset': 'Eiendel',
  'asset.soldOnLabel': 'solgt {date}',
  'asset.acquiredInline': 'Anskaffet {date}',
  'asset.groupRateInline': 'Gruppe {group} · {rate} %',
  'asset.colAcquired': 'Anskaffet',
  'asset.colCost': 'Kostpris',
  'asset.costInline': 'Kostpris {amount}',
  'asset.colStatus': 'Status',
  'asset.decliningDescription': 'Grunnlag for saldoavskrivning per gruppe. RF-1084 / RF-1217 vises som skjemareferanser for norsk skattelogikk.',
  'asset.depreciationInline': 'Avskrivning −{amount}',
  'asset.atYearEnd': 'Ved utgangen av {year}',
  'asset.accountingValue': 'Regnskapsmessig verdi',
  'asset.taxValue': 'Skattemessig verdi',
  'asset.temporaryDifference': 'Midlertidig forskjell',
  'asset.noCustomer': 'Uten kunde',
  'asset.fallbackNoun': 'eiendel',
  'asset.saleLineDescription': 'Salg av {name}',
  'asset.deletedStatus': 'Slettet',
  'asset.updateFailed': 'Kunne ikke oppdatere eiendelen.',
  'asset.transitionSaved': 'Overgangsverdier og vurdering er lagret.',
  'asset.transitionSaveFailed': 'Kunne ikke lagre overgangsverdiene.',
  'asset.soldPendingOther': "Fullfør Annet salg for å registrere eiendelen som solgt",
  'asset.soldPendingInvoice': "Opprett fakturaen for å registrere eiendelen som solgt",
  'asset.registeredSold': 'Eiendel registrert som solgt',
  'asset.detailTitle': 'Eiendel: {name}',
  'asset.tabInfo': 'Informasjon',
  'asset.tabDepreciationChanges': 'Avskrivning / endringer',
  'asset.tabForms': 'Skjemaer',
  'asset.purchaseDate': 'Kjøpsdato',
  'asset.purchasePrice': 'Kjøpspris',
  'asset.assetAccountLabel': 'Eiendelskonto',
  'asset.missingValue': 'Mangler',
  'asset.usefulLifeLabel': 'Økonomisk levetid',
  'asset.yearsCount': '{n} år',
  'asset.taxDepreciationRateLabel': 'Skattemessig avskrivningssats',
  'asset.impairmentAssessmentYear': 'Verdifallsvurdering {year}',
  'asset.noIndicators': 'Ingen indikatorer',
  'asset.impairedAmount': 'Nedskrevet {amount}',
  'asset.transitionHeading': 'Overgang til Plumme',
  'asset.transitionBody': 'Historiske bokførte verdier beholdes. Registrer separat skattemessig inngangsverdi og faglig plan for videre årsavslutning.',
  'asset.registerTransitionValues': 'Registrer overgangsverdier',
  'asset.colYear': 'År',
  'asset.colType': 'Type',
  'asset.colDescription': 'Beskrivelse',
  'asset.colAccountingChange': 'Regnskapsmessig endring',
  'asset.colNewValue': 'Ny verdi',
  'asset.sellTitle': 'Registrer eiendel som solgt: {name}',
  'asset.sellNoInvoice': 'Registrer salg uten faktura',
  'asset.createInvoiceBtn': 'Lag faktura',
  'asset.markSoldBtn': 'Marker som solgt',
  'asset.gainOnSale': 'Gevinst ved salg',
  'asset.lossOnSale': 'Tap ved salg',
  'asset.sellMethodMarkDesc': 'Brukes når salgsinntekten allerede er bokført.',
  'asset.sellMethodOtherDesc': 'Åpner Annet salg med eiendelen forhåndsutfylt.',
  'asset.sellMethodInvoiceDesc': 'Åpner nytt fakturautkast med eiendelen som linje.',
  'asset.sellHelperPrefix': 'Salget reduserer avskrivningssaldoen i gruppe {group}.',
  'asset.sellHelperMarkSuffix': 'Velg dette kun når inntekten allerede er bokført.',
  'asset.sellHelperOtherSuffix': 'Vi tar deg videre for å bokføre selve salgsinntekten.',
  'asset.continueDeleteBody': 'Bruk dette bare hvis eiendelen ble registrert ved en feil og ikke skal avskrives. Utførte årsavslutnings-/avskrivningsposter bør reverseres før eiendelen markeres som slettet.',
  'asset.markedDeleted': 'Eiendel markert som slettet',
  'asset.restoreDeleteBody': 'Dette gjør eiendelen aktiv igjen og tar den med i saldogruppe, skattemessig verdi og avskrivningsgrunnlag. Hvis du har kjørt årsavslutning eller bokført avskrivninger mens eiendelen var slettet, bør disse kontrolleres og eventuelt reverseres før du fortsetter.',
  'asset.deleteUndone': 'Sletting angret',
  'asset.restoreSaleBody': 'Plumme gjør eiendelen aktiv igjen med sporbare motposteringer. Velg nedenfor om et tilknyttet salgsbilag også skal reverseres eller beholdes. Originalbilagene beholdes, og låste perioder må åpnes før bokføringen kan endres.',
  'asset.saleUndone': 'Salg angret',
  'asset.transitionTitle': 'Overgangsverdier: {name}',
  'asset.saveAssessment': 'Lagre vurdering',
  'asset.savingEllipsis': 'Lagrer…',
  'asset.planStartLabel': 'Planstart i Plumme',
  'asset.remainingUsefulLifeYearsLabel': 'Gjenstående økonomisk levetid (år)',
  'asset.taxOpeningValueYear': 'Skattemessig inngående verdi {year}',
  'asset.impairmentToBeRecordedShort': 'Nedskrivning registreres',
  'asset.impairmentAmountLabel': 'Nedskrivningsbeløp',
  'asset.documentationLabel': 'Dokumentasjon / begrunnelse',
  'asset.importedHistoryUnchanged': 'Importert historikk endres ikke. Planen starter med bokført verdi ved inngangen til året og holdes separat fra skattemessig verdi.',
  'asset.nameRequired': 'Navn på driftsmiddel må fylles ut.',
  'asset.amountMustBePositive': 'Beløp må være større enn 0.',
  'asset.planFieldsInvalid': 'Fyll ut en gyldig bruksklar dato, økonomisk levetid og restverdi.',
  'asset.assessImpairmentRequired': 'Vurder tegn på verdifall for {year}.',
  'asset.impairmentAmountRequired': 'Oppgi nedskrivningsbeløpet.',
  'asset.draftContentRequired': 'Legg inn navn, linje eller vedlegg før du lagrer utkast.',
  'asset.updated': 'Eiendel oppdatert',
  'asset.registeredDepreciating': 'Eiendel registrert - avskrives ved årsavslutning',
  'asset.saveFailed': 'Kunne ikke lagre eiendelen.',
  'asset.attachmentAdded': 'Vedlegg lagt til.',
  'asset.savingDots': 'Lagrer...',
  'asset.registerAssetBtn': 'Registrer eiendel',
  'asset.bookDepreciationPanelTitle': 'Regnskapsmessig avskrivningsplan',
  'asset.bookDepreciationPanelDesc': 'Planen styrer bokført verdi. Saldogruppen under brukes bare for skatt.',
  'asset.usefulLifeYearsFieldLabel': 'Økonomisk levetid (år)',
  'asset.noImpairmentIndicatorsOption': 'Ingen indikatorer på verdifall',
  'asset.impairmentToBeRecordedOption': 'Nedskrivning skal registreres',
  'asset.documentationPlaceholder': 'Kort begrunnelse eller referanse til dokumentasjon',
  'asset.supplierPurchaseHelp': 'Koble eiendelen til leverandør og fakturanummer når kjøpet kommer fra leverandørfaktura.',
  'asset.noDescriptionFallback': 'Uten beskrivelse',
  'asset.amountModeGross': 'inkl. MVA',
  'asset.amountModeNet': 'eks. MVA',
  'asset.hideVoucher': 'Skjul bilag',
  'asset.showVoucher': 'Vis bilag',
  'asset.reclassAcct6540': 'Inventar',
  'asset.reclassAcct7700': 'Annen kostnad',
  'asset.missingFileLink': 'Mangler fil-lenke',
  'asset.cannotPreviewInBrowser': 'Kan ikke forhåndsvises i nettleseren.',
  'asset.automaticPostingExplanation': 'Avskrivninger bokføres automatisk for hver fullførte måned. Plumme tar igjen manglende måneder uten at du trenger å gjøre noe.',
  'asset.automaticPostingNeedsReview': 'Automatisk avskrivning trenger oppfølging. Kontroller eiendelens plan eller kontakt support. Plumme prøver igjen når avviket er rettet.',
  'asset.automaticScopeUnsupported': 'Automatisk avskrivning støttes foreløpig bare for støttede norske regnskapsoppsett.',
  'asset.automaticCorrectionRequired': 'Fullfør korrigeringen av avskrivningsplanen etter reverseringen. Deretter fortsetter automatisk bokføring.',
  'asset.automaticPostingThrough': 'Siste bokførte avskrivning: {date}.',
  'asset.automaticPostingPending': '{amount} gjenstår til og med {date}. Plumme følger opp bokføringen automatisk.',
});

window.PlummeI18n.register('no', {
  "err.nativeValidation.fixedAssetAcquisitionRegistration.1": "Velg én eksisterende anskaffelse som skal registreres.",
  "err.nativeValidation.fixedAssetAcquisitionRegistration.2": "Anskaffelsen er allerede registrert som driftsmiddel.",
  "err.nativeValidation.fixedAssetAcquisitionRegistration.3": "Registreringsdatoen må samsvare med den opprinnelige anskaffelsen.",
});

window.PlummeI18n.register("no", {
  "purchaseFlow.overview": "Kjøpsoversikt",
  "purchaseFlow.search": "Søk etter kjøp",
  "purchaseFlow.status": "Status",
  "purchaseFlow.all": "Alle",
  "purchaseFlow.empty": "Ingen kjøp funnet.",
  "purchaseFlow.creditNumber": "Kreditnotanummer",
  "purchaseFlow.creditNumberRequired": "Oppgi leverandørens kreditnotanummer.",
  "purchaseFlow.documents": "Vedlegg",
  "purchaseFlow.original": "Gjelder faktura",
  "purchaseFlow.reverse": "Annuller betaling",
  "purchaseFlow.reverseExplanation": "Hele betalingen tilbakeføres, også dersom den dekker flere fakturaer. Historikken beholdes.",
  "purchaseFlow.reason": "Begrunnelse",
  "purchaseFlow.more": "Flere handlinger"
});

window.PlummeI18n.register("no", {"purchaseFlow.paymentTotal": "Hele betalingen: {amount}"});

window.PlummeI18n.register("no", {
  "err.supplierPayment.selectionRequired": "Velg faktura for betalingen.",
  "err.supplierCredit.numberRequired": "Oppgi leverandørens kreditnotanummer.",
  "err.supplierCredit.conflict": "Kreditnotaen samsvarer ikke med det lagrede dokumentet.",
  "err.supplierCredit.duplicate": "Leverandørens kreditnotanummer er allerede registrert."
});

window.PlummeI18n.register("no", {"purchaseFlow.purchase": "Kjøp", "purchaseFlow.net": "Netto", "purchaseFlow.vat": "MVA"});

window.PlummeI18n.register("no", {"asset.rename": "Endre navn"});



window.PlummeI18n.register("no", {"asset.cancelDates": "Kjøpet fra {purchase} og de tilknyttede føringene motposteres {date}. Opprinnelige bilag og datoer beholdes.", "err.asset.cancelDetailsRequired": "Oppgi en begrunnelse og bruk en dato på eller etter kjøpsdatoen.", "err.asset.laterChangesRequired": "Avklar senere eiendelsendringer eller avskrivninger uten entydig eiendel før salget registreres."});
